import { FC } from 'react';

import useTrls from 'hooks/translation/useTrls';

const Active: FC = () => {
    const trl = useTrls();

    return <div>{trl('campaign.actions.status.pausedOrActive.active')}</div>;
};

export default Active;
